<template>
  <!--shade is the darker background of the modal-->
  <div id="shade">
      <div id="modal">
        <div id="head">
          <!--modal header-->
          <p>Buchung eines Parkplatzes - {{ dateString }}</p>
          <button id="close" @click="this.$emit('closemodal')"><font-awesome-icon class="i-icon" :icon="['fas', 'xmark']" /></button>
          
        </div>
        <!--colorcode sets the background color, indicating state of bookings-->

        <div id="am" :class="colorCodeAm + ' set'" >
          <div>
            <h1>Vormittags</h1>
            <p>00:00 - 12:00 Uhr</p>
          </div>
          <div v-show="!isToday() || isBefore12()">
            <button
              v-if="colorCodeAm === 'green' && bookingCountNow"
              @click="bookIt('am')"
            >
              Parkplatz buchen
            </button>
            <button
              v-if="colorCodeAm === 'blue'"
              @click="cancelSpace('am')"
              class="storno"
            >
              Stornieren
            </button>
          </div>
          <div>
            <p v-if="remainingSpacesAm >= 0">Verfügbar:</p>
            <p v-else>Gebuchter Parkplatz</p>

            <p v-if="remainingSpacesAm >= 0">{{ remainingSpacesAm }}</p>
            <HoverToolTip v-else text="Die Buchung gestattet es einen der freien Parkplätze an den Ladesäulen für die gebuchte Tageszeit einzunehmen. Die linke Säule mit beiden Steckern ist davon ausgeschlossen!"/>
          </div>
        </div>


        <div id="pm" :class="colorCodePm + ' set'">

          <div>
            <h1>Nachmittags</h1>
            <p>12:00 - 00:00 Uhr</p>
          </div>

          <div>
            <button
              v-if="colorCodePm === 'green' && bookingCountNow"
              @click="bookIt('pm')"
            >
              Parkplatz buchen
            </button>
            <button
              v-if="colorCodePm === 'blue'"
              @click="cancelSpace('pm')"
              class="storno"
            >
              Stornieren
            </button>
          </div>
          <div>
            <p v-if="remainingSpacesPm >= 0">Verfügbar:</p>
            <p v-else>Gebuchter Parkplatz</p>

            <p v-if="remainingSpacesPm >= 0">{{ remainingSpacesPm }}</p>
            <HoverToolTip v-else text="Die Buchung gestattet es einen der freien Parkplätze an den Ladesäulen für die gebuchte Tageszeit einzunehmen. Die linke Säule mit beiden Steckern ist davon ausgeschlossen!"/>
          </div>
        </div>
      </div>
      <LoaderView :show="working"/>
  </div>
</template>

<script>
import HoverToolTip from "./HoverToolTip.vue"
import { httpsCallable, getFunctions } from "firebase/functions";
import { firebase, region } from "../plugins/firebase";
import LoaderView from "./LoaderView.vue"

export default {
  name: "BookingModal",
  components: {
    LoaderView,
    HoverToolTip,
  },
  props: {
    dayPackage: Object,
    bookingCount: Number,
  },
  data() {
    return {
      dateString: "",
      colorCodeAm: "green",
      colorCodePm: "green",
      remainingSpacesAm: 0,
      remainingSpacesPm: 0,
      maxSpaces: 4,
      weekday: 0,
      package: {},
      showInfo: false,
      showInfo2: false,
      bookingCountNow: 0,
      working: false,
    };
  },
  methods: {
    processData() {
      //extracting recieved data for easier use
      this.package = this.dayPackage.package;
      //date string for date display in modal header
      this.createDateString();
      //sets variables for booking organisation
      this.processBookings(this.package.am, this.package.pm);
    },
    createDateString() {
      const datePieces = this.package.date.split("-");
      let day = datePieces[0];
      if (day < 10) day = "0" + String(day);
      let month = Number(datePieces[1]) + 1;
      if (month < 10) month = "0" + String(month);

      const dateString = " " + day + "." + month + ".";
      this.dateString = dateString;
    },
    isToday() {
      const dateString = this.dayPackage.package.date;
      console.log(dateString)
      const date = new Date();
      const newDay = date.getDate();
      const newMonth = date.getMonth();
      const newYear = date.getFullYear();
      const newDateString = String(newDay) + "-" + String(newMonth) +
      "-" + String(newYear);
      return newDateString === dateString ? true : false;
    },
    isBefore12(){
      const currentTime = new Date();
      const currentHour = currentTime.getHours();
      return currentHour < 12 ? true : false;
    },
    processBookings(am, pm) {
      //changes background color for booking indications
      this.remainingSpacesAm = this.maxSpaces - am;
      this.remainingSpacesPm = this.maxSpaces - pm;

      if (this.remainingSpacesAm === 0) this.colorCodeAm = "red";
      if (this.remainingSpacesAm > 0) this.colorCodeAm = "green";
      if (this.remainingSpacesAm < 0) this.colorCodeAm = "blue";

      if (this.remainingSpacesPm === 0) this.colorCodePm = "red";
      if (this.remainingSpacesPm > 0) this.colorCodePm = "green";
      if (this.remainingSpacesPm < 0) this.colorCodePm = "blue";
    },
    bookIt(time) {
      this.working = true
      //initiates booking with firebase function
      let bookingPackage = {
        time: time,
        date: this.package.date,
      };
      const saveBooking = httpsCallable(getFunctions(firebase, region), "saveBooking");
      saveBooking({ bookingPackage })
      .then((result) => {
        // Read result of the Cloud Function.
        /** @type {any} */
        const answer = result.data;
        this.bookingCountNow--;
        if (answer) {
          if (time === "am") {
            this.colorCodeAm = "blue";
            this.remainingSpacesAm = -1;
          } else {
            this.colorCodePm = "blue";
            this.remainingSpacesPm = -1;
          }
          //this.$emit("refresh");
        } else {
          // error
        }
        this.working = false
      })
      .catch(err=>{
        console.log(err)
        this.working = false
      });
    },
    cancelSpace(time) {
      this.working = true
      //deletion process
      let cancelPackage = {
        time: time,
        date: this.package.date,
      };
      //cancels booking via firebase function
      const cancelBooking = httpsCallable(getFunctions(firebase, region), "cancelBooking");
      cancelBooking({ cancelPackage })
      .then((result) => {
        // Read result of the Cloud Function.
        /** @type {any} */
        const answer = result.data;

        if (answer) {
          this.bookingCountNow++;
          if (time === "am") {
            this.colorCodeAm = "green";
            this.remainingSpacesAm = 1;
          } else {
            this.colorCodePm = "green";
            this.remainingSpacesPm = 1;
          }
        } else {
          // error
        }
        this.working = false
      })
      .catch(err=>{
        console.log(err)
        this.working = false
      });
    },
  },
  beforeMount() {
    this.processData();
    this.bookingCountNow = this.bookingCount;
  },
};
</script>

<style scoped>
#shade {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.25);
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

#modal {
  background-color: white;
  max-width: 600px;
  width: calc(100% - 10px);
  margin: 10px;
  /* border: 1px solid rgb(200, 200, 200); */
  border-radius: 12.5px;
}

#head {
  position: relative;
  background-color: #4089c9;
  border-radius: 12.5px 12.5px 0 0;
  display: flex;
  padding: 5px 15px;
}

#head p {
  margin: 5px 25px 0 0;
  color: white;
  font-weight: 500;
  font-size: 1.3em;
}

#head button {
  background: transparent;
  border: none;
  color: white;
  margin-left: auto;
  width: fit-content;
  padding: 5px;
}

#head button:hover {
  color: lightgray;
  cursor: pointer;
}

#am,
#pm {
  margin-top: 25px;
  margin: 10px 0;
}

#pm {
  margin-bottom: 25px;
}

.set {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
}

.set h1{
  width: 200px;
  margin: 5px 0px;
  color: #5e5e5e;
  font-size: 1.5em;
  font-weight: 400;
  text-align: left;
}

.set p {
  width: 200px;
  margin: 0;
  color: #5e5e5e;
  font-size: 1em;
  text-align: left;
}

.set h1{
  text-align: left;
}

.set > div:last-child p {
  text-align: right;
}

button {
  padding: 10px;
  width: 150px;
  background-color: #4089c9;
  color: white;
  border: none;
  border-radius: 7.5px;
}

button:hover {
  background-color: #2f6fa7;
  cursor: pointer;
}

.btn-disabled {
  background-color: #939393;
}

.btn-disabled:hover {
  background-color: #939393;
  cursor: default;
}

.green {
  background-color: #ebffe5;
}

.red {
  background-color: #ffe5e5;
}

.blue {
  background-color: #e5f2ff;
}

.info-button {
  padding: 5px;
  border: 1px solid gray;
  border-radius: 5px;
}
button.storno {
  background-color: rgb(255, 33, 33);
}
button.storno:hover {
  background-color: rgb(214, 4, 4);
}
#close {
  font-size: 20px;
}
button { 
  margin: 5px;
}

@media screen and (max-width:600px) {
  .set {
    display: flex; 
    flex-direction: column;
  }
  .set p, 
  .set h1{
    text-align: center!important;;
  }
}
</style>